var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "#E8F0F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3332 22.7735V24.0001C37.3315 26.8754 36.4005 29.673 34.679 31.9759C32.9574 34.2788 30.5376 35.9635 27.7803 36.7787C25.0231 37.5939 22.0762 37.496 19.3791 36.4996C16.6821 35.5032 14.3794 33.6616 12.8145 31.2496C11.2495 28.8375 10.5062 25.9842 10.6954 23.1152C10.8846 20.2462 11.9961 17.5152 13.8642 15.3296C15.7323 13.1439 18.2569 11.6207 21.0614 10.987C23.866 10.3534 26.8002 10.6433 29.4265 11.8135M19.9998 22.6667L23.9998 26.6667L37.3332 13.3333",
    stroke: "#295D92",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.65d120211730ed9dbcaf9748627b0352.svg";
export { ForwardRef as ReactComponent };